import React from 'react';
import { Box, costFormater, List } from '@common-fe/common-fe';

import { useGetFundIcon } from '../../hooks';
import { FundPayload } from '../../SelfDirected/SelfDirected.types';
interface Props extends FundPayload {
  onClick: () => void;
}
const FundPreviewCard: React.FC<Props> = ({ id, title, stockCode, logo, amount, election, onClick }) => {
  const handleGetFundIcon = useGetFundIcon();

  return (
    <List.Item
      testId={`fund-preview_${id}`}
      onClick={onClick}
      pad="s"
      key={id}
      height={{ min: '62px' }}
      round="container1Round"
    >
      {handleGetFundIcon({
        image: logo,
        // status: status,
        isGreyMode: false,
        isNullMode: true,
      })}
      <Box direction="column" fill margin={{ left: 'xs' }}>
        <List.Item.Text data-testId={`fund-preview_${id}_title`} truncate weight={700}>
          {title}
        </List.Item.Text>
        <List.Item.Text data-testId={`fund-preview_${id}_symbol`} size="small" color="textSecondary">
          {stockCode}
        </List.Item.Text>
      </Box>

      <div>
        <Box direction="column" margin={{ left: 'xl' }} align="end">
          <List.Item.Text weight={700} data-testId={`fund-preview_${id}_value`}>
            {costFormater(amount, {
              isPrecision: true,
            })}
          </List.Item.Text>
          <List.Item.Text data-testId={`fund-preview_${id}_election`} size="small" color="textSecondary">
            {`${election || 0}%`}
          </List.Item.Text>
        </Box>
      </div>
    </List.Item>
  );
};
export default FundPreviewCard;
